import React, { useEffect } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { Modal, Box, Button, Typography } from "@mui/material";
import Login from "./pages/Login";
import LoginFiestasQuito from "./pages/LoginFiestasQuito";
import LoginNavidad from "./pages/LoginNavidad";
import Desayuno from "./pages/Desayuno";
import Home from "./pages/Home";
import TitleUpdater from "./components/TitleUpdater";
import PaginaNotFound from "./pages/PaginaNotFound";
import PrivateRoute from "./components/PrivateRoute";
import Ciudadanos from "./pages/Ciudadanos";
import TimerOffIcon from "@mui/icons-material/TimerOff";
import DataProtection from "./pages/DataProtection";
import GestorVirtual from "./pages/GestorVirtual";
import SolicitudCredito from "./pages/SolicitudCredito";
import NuevaSolicitud from "./pages/NuevaSolicitud";
import Documento1 from "./pages/Documento1";
import VerificacionTelefonica from "./pages/VerificacionTelefonica";
import ListaSolicitud from "./pages/ListaSolicitud";
import CarteraBancoSolidarioPage from "./pages/CarteraBancoSolidarioPage";
import VerificacionTerrena from "./pages/VerificacionTerrena";
import VerificacionGeoreferencia from "./pages/VerificacionGeoreferencia";
import SolicitudGrande from "./pages/SolicitudGrande";
import Seguridad from "./pages/Seguridad";
import TelefonicaListSol from "./pages/TelefonicaListSol";
import GestorDocumentosCli from "./pages/GestorDocumentos";
import GestorDocumentosFirmaCli from "./pages/GestorDocumentosFirma";
import { useAuth } from "./components/AuthContext/AuthContext";
import { GoogleMapsProvider } from "./components/GoogleMapsProvider/GoogleMapsProvider";
import { SipProvider, useSip } from "./components/SipContext";
import PhonePanel from "./components/PhonePanel/PhonePanel";
import RepositorioCreditos from "./pages/RepositorioCreditos";
import CalendarioOperador from "./pages/CalendarioOperador";
import CalendarioVerificador from "./pages/CalendarioVerificador";
import AgenteDocumental from "./pages/AgenteDocumental";
import Dashboard from "./pages/Dashboard";
import ListaNegra from "./pages/ListaNegra";
import NotificacionesCli from "./pages/Notificaciones";
import NotificationToast from "./components/NotificationToast/NotificationToast";

import Equifax from "./pages/Equifax";

import DepositoPendiente from "./pages/DepositoPendiente";
import ListaNegraCedula from "./pages/ListaNegraCedulas";
import ClientesBuenosMotos from "./pages/ClientesBuenosMotos";
import ListaNegraEmail from "./pages/ListaNegraEmails";
import MapaPantalla from "./pages/MapPantalla"
import CumpleañosPagina from "./pages/CumpleañosPag"
import ReporteEncuestas from "./pages/ReporteEncuestas";
import InformesCobranza from "./pages/InformesCobranza";
import DetalleCobranzaPage from "./pages/DetalleCobranzaPage";
import MensajesCobranza from "./pages/MensajesCobranzas";
import Score from "./pages/Score";
import EstrategiaCallCenter from "./pages/EstrategiaCallCenter";
import AsignacionAgentes from "./pages/AsignacionAgentes";
import ClientesRecurrentes from "./pages/ClientesRecurrentes";
import RescatesClientes from "./pages/Rescatesclientes"
import TipoCartera from "./pages/TipoCartera";
import Acciones from "./pages/Acciones";
import EstructuraAgentesCobranza from "./pages/EstructuraAgentesCobranza";
import Cobranzas from "./pages/Cobranzas";
import HistorialCobr from "./pages/HistorialCobranzas"
import Seguimiento from "./pages/Seguimiento";
import NuevaSolicitudYupana from "./pages/NuevaSolicitudYupana";
import DocumentalBancoSolidarioPage from "./pages/DocumentalBancoSolidario";
import ExtensionesTelefonicas from "./pages/ExtensionesTelefonicas";
import SimuladorMetas from "./pages/SimuladorMetas";

import CumplimientoVentasVendedor from "./pages/CumplimientoVentasVendedor";
import MiDocumentoMensual from "./pages/MiDocumentoMensual";
import AdminDocumentosMensuales from "./pages/AdminDocumentosMensuales";
function AuthenticatedPhonePanel({ token }) {
  const { disconnect, phoneAvailable } = useSip();

  useEffect(() => {
    if (!token) {
      disconnect();
    }
  }, [token, disconnect]);

  return token && phoneAvailable ? <PhonePanel /> : null;
}

// Definido FUERA de App para que React nunca lo trate como un tipo nuevo en cada render.
// Si estuviera dentro de App(), cada re-render crearía una nueva referencia de función,
// lo que provocaría que React desmonte y remonte todos los hijos (destruyendo formularios).
const PrivateRouteWrapper = ({ title, element }) => (
  <PrivateRoute>
    <TitleUpdater title={`${title} - POINT`} />
    {element}
  </PrivateRoute>
);

function App() {

  const { isSessionExpired, logout, token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = window.location.pathname;

    if (!token && currentPath !== "/FelizCumpleaños" && !currentPath.startsWith("/mapScreenLatinium")) {
      navigate("/login");
    }
  }, [token, navigate]);

  return (

    <SipProvider>
    <GoogleMapsProvider>
    <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: "top", horizontal: "right" }} autoHideDuration={3500}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/desayuno" element={<Desayuno />} />
		    <Route path="/FelizCumpleaños" element={<CumpleañosPagina />} />

        <Route path="/mapScreenLatinium/:bodega/:cedula/:tipo/:codigoEntrega" element={<MapaPantalla />} />
        
        {/* Rutas de reporte de encuestas */}
        <Route
          path="/reporte-encuestas"
          element={
            <PrivateRoute>
              <ReporteEncuestas />
            </PrivateRoute>
          }
        />

        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/*" element={<><TitleUpdater title="Página no encontrada - POINT" /><PaginaNotFound /></>} />

        <Route path="/dashboard" element={<PrivateRouteWrapper title="dashboard" element={<Dashboard />} />} />
        <Route path="/nueva-consulta" element={<PrivateRouteWrapper title="Nueva Consulta" element={<Home />} />} />
        <Route path="/ciudadanos" element={<PrivateRouteWrapper title="Ciudadanos Almacenados" element={<Ciudadanos />} />} />
        <Route path="/proteccion-datos" element={<PrivateRouteWrapper title="Protección de Datos" element={<DataProtection />} />} />
        <Route path="/gestor" element={<PrivateRouteWrapper title="Gestor Virtual" element={<GestorVirtual />} />} />
        <Route path="/calendar" element={<PrivateRouteWrapper title="calendar Virtual" element={<CalendarioOperador />} />} />
        <Route path="/calendarVerificador" element={<PrivateRouteWrapper title="calendar Virtual" element={<CalendarioVerificador />} />} />
        <Route path="/solicitud" element={<PrivateRouteWrapper title="Solicitud" element={<SolicitudCredito />} />} />
        <Route path="/nuevasolicitud" element={<PrivateRouteWrapper title="Nueva Solicitud" element={<NuevaSolicitud />} />} />
        <Route path="/documental" element={<PrivateRouteWrapper title="Documentos" element={<Documento1 />} />} />
        <Route path="/telefonica" element={<PrivateRouteWrapper title="Telefonica" element={<VerificacionTelefonica />} />} />
        <Route path="/terrena" element={<PrivateRouteWrapper title="Terrena" element={<VerificacionTerrena />} />} />
        <Route path="/georeferencia" element={<PrivateRouteWrapper title="Georeferencia" element={<VerificacionGeoreferencia />} />} />
        <Route path="/solicitudgrande" element={<PrivateRouteWrapper title="SolicitudGrande" element={<SolicitudGrande />} />} />
        <Route path="/ListadoSolicitud" element={<PrivateRouteWrapper title="Tabla" element={<ListaSolicitud />} />} />
        <Route path="/cartera/banco-solidario" element={<PrivateRouteWrapper title="Cartera Banco Solidario" element={<CarteraBancoSolidarioPage />} />} />
        <Route path="/point/credito/seguridad" element={<PrivateRouteWrapper title="Seguridad" element={<Seguridad />} />} />
        <Route path="/telefonicaList" element={<PrivateRouteWrapper title="Telefonica Lista Solicitud" element={<TelefonicaListSol />} />} />
        <Route path="/gestorDocumentos" element={<PrivateRouteWrapper title="Gestor Documentos" element={<GestorDocumentosCli />} />} />
        <Route path="/gestorDocumentosFirma" element={<PrivateRouteWrapper title="Gestor Documentos Firma" element={<GestorDocumentosFirmaCli />} />} />
        <Route path="/repositorio" element={<PrivateRouteWrapper title="Repositorio" element={<RepositorioCreditos />} />} />
        <Route path="/agentedocumental" element={<PrivateRouteWrapper title="Repositorio" element={<AgenteDocumental />} />} />
        <Route path="/listaNegra" element={<PrivateRouteWrapper title="ListaNegra" element={<ListaNegra />} />} />
        <Route path="/equifaxx" element={<PrivateRouteWrapper title="Equifax" element={<Equifax />} />} />
        <Route path="/depositoPendiente" element={<PrivateRouteWrapper title="Deposito Pendiente" element={<DepositoPendiente />} />} />
        <Route path="/notificaciones" element={<PrivateRouteWrapper title="Notificaciones" element={<NotificacionesCli />} />} />
        <Route path="/ListaNegraCedulas" element={<PrivateRouteWrapper title="ListaNegraCedula" element={<ListaNegraCedula />} />} />
        <Route path="/ClientesBuenosMotos" element={<PrivateRouteWrapper title="ClientesBuenosMotos" element={<ClientesBuenosMotos />} />} />
        <Route path="/ListaNegraEmails" element={<PrivateRouteWrapper title="ListaNegraEmail" element={<ListaNegraEmail />} />} />
        <Route path="/informesCobranza" element={<PrivateRouteWrapper title="InformesCobranza" element={<InformesCobranza />} />} />
        <Route path="/detalle-cobranza/:sCre_SolicitudWeb" element={<PrivateRouteWrapper title="Detalle Cobranza" element={<DetalleCobranzaPage />} />} />
        <Route path="/mensajescobranza" element={<PrivateRouteWrapper title="MensajeCobranza" element={<MensajesCobranza />} />} />
        <Route path="/estrategiacall" element={<PrivateRouteWrapper title="Estrategia Call Center" element={<EstrategiaCallCenter />} />} />
        <Route path="/asignacionagentes" element={<PrivateRouteWrapper title="Asignación Agentes" element={<AsignacionAgentes />} />} />
        <Route path="/estructura-agentes-cobranza" element={<PrivateRouteWrapper title="Estructura Agentes Cobranza" element={<EstructuraAgentesCobranza />} />} />
        <Route path="/clientes-recurrentes" element={<PrivateRouteWrapper title="Clientes Recurrentes" element={<ClientesRecurrentes />} />} />
        <Route path="/scoreCobranzas" element={<PrivateRouteWrapper title="ScoreCobranzas" element={<Score />} />} />
	    	<Route path="/rescateclientes" element={<PrivateRouteWrapper title="RescatesClientes" element={<RescatesClientes />} />} />
        <Route path="/tipo-cartera" element={<PrivateRouteWrapper title="Tipo Cartera" element={<TipoCartera />} />} />
        <Route path="/acciones" element={<PrivateRouteWrapper title="Acciones" element={<Acciones />} />} />
		    <Route path="/historialCobranzas" element={<PrivateRouteWrapper title="Historial Cobranza" element={<HistorialCobr />} />} />
	    	<Route path="/cobranzza" element={<PrivateRouteWrapper title="Cobranza" element={<Cobranzas />} />} />
        <Route path="/ticket-sistemas" element={<PrivateRouteWrapper title="Seguimiento" element={<Seguimiento />} />} />
        <Route path="/nueva-solicitud-yupana" element={<PrivateRouteWrapper title="Nueva Solicitud Yupana" element={<NuevaSolicitudYupana />} />} />
        <Route path="/documental-banco-solidario" element={<PrivateRouteWrapper title="Documentos Banco Solidario" element={<DocumentalBancoSolidarioPage />} />} />
        <Route path="/extensiones-telefonicas" element={<PrivateRouteWrapper title="Extensiones Telefónicas SIP" element={<ExtensionesTelefonicas />} />} />
        <Route path="/simulador-metas" element={<PrivateRouteWrapper title="Simulador de Cumplimiento" element={<SimuladorMetas />} />} />
        <Route path="/cumplimiento-ventas-vendedor" element={<PrivateRouteWrapper title="Cumplimiento Ventas Vendedor" element={<CumplimientoVentasVendedor />} />} />
        <Route path="/mi-documento-mensual"       element={<PrivateRouteWrapper title="Mi Documento Mensual"           element={<MiDocumentoMensual />}         />} />
        <Route path="/admin-documentos-mensuales" element={<PrivateRouteWrapper title="Admin Documentos Mensuales"      element={<AdminDocumentosMensuales />}    />} />

      </Routes>

      <NotificationToast />

      {isSessionExpired && (
        <Modal open={isSessionExpired} onClose={() => { }}>
          <Box sx={{
            position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
            width: 400, bgcolor: "background.paper", borderRadius: "8px", boxShadow: 24, p: 4, textAlign: "center"
          }}>
            <Typography variant="h6" component="h2">Sesión terminada <TimerOffIcon /></Typography>
            <Typography sx={{ mt: 2 }}>
              Tu sesión ha expirado. Haz clic en "Aceptar" para volver a iniciar sesión.
            </Typography>
            <Button onClick={logout} variant="contained" sx={{
              mt: 3, backgroundColor: "#2d3689", color: "#ffffff", "&:hover": { backgroundColor: "#212863", color: "#ffffff" }
            }}>
              Aceptar
            </Button>
          </Box>
        </Modal>
      )}
    </SnackbarProvider>
    </GoogleMapsProvider>
    <AuthenticatedPhonePanel token={token} />
    </SipProvider>

  );
}

export default App;
